import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ContactLookupProvider } from '../../contact/core/contact-lookup.provider';
import { ContactService } from '../../contact/core/contact.service';
import { IFilterLookupProvider } from '../../core/filter/filter-lookup.provider';
import { FilterService } from '../../core/filter/filter.service';
import { CustomerLookupProvider } from '../../customer/core/customer-lookup.provider';
import { CustomerService } from '../../customer/core/customer.service';
import { DictionaryService } from '../../dictionary/core/dictionary.service';
import { LookupModelLookupProvider } from "../../dictionary/core/lookup-model-lookup.provider";
import { LOOKUP_MODELS_ENUM } from '../../dictionary/core/lookup-models.enum';
import { UserSettingsService } from '../../user/core/user-settings.service';
import { quotingFilterContext } from "./quoting-filter.context";
import { DefaultDateRangesLookupProvider } from 'app/core/filter/default-date-ranges-lookup.provider';

export class QuoteStatusLookupProvider extends IFilterLookupProvider {
  lookupModel: string = LOOKUP_MODELS_ENUM.QUOTE_HEADER_STATUS.modelName;

  constructor(public dictionaryService: DictionaryService) {
    super();
  }

  findAll(searchQuery?): Observable<any> {
    return this.dictionaryService.getByLookup(this.lookupModel, searchQuery)
      .map((result) => {
        return result.items.map((entry) => {
          return {
            key: entry.id,
            value: entry.value
          };
        });
      });
  }
}

@Injectable()
export class QoutingFilterService extends FilterService {
  customRanges: any = [
    {
      'label': 'Last 2 years'
    },
    {
      'label': 'Last 6 months'
    }
  ];

  excludeRanges: any = [
    {
      'label': 'Prior month'
    },
    {
      'label': 'Last week'
    },
  ];

  constructor(public dictionaryService: DictionaryService,
              public customerService: CustomerService,
              public contactService: ContactService,
              public userSettingsService: UserSettingsService) {
    super('app.quoting.quoting-filter', quotingFilterContext, userSettingsService);
    this.addLookupProvider('employee', new ContactLookupProvider(contactService));
    this.addLookupProvider('customer', new CustomerLookupProvider(customerService));
    this.addLookupProvider('quoteStatus', new QuoteStatusLookupProvider(dictionaryService));
    this.addLookupProvider('sales_representative', new ContactLookupProvider(contactService));
    this.addLookupProvider('sales_engineer', new ContactLookupProvider(contactService));
    this.addLookupProvider('defaultDateRanges', new DefaultDateRangesLookupProvider(this.customRanges, this.excludeRanges, true));
    this.addLookupProvider('opportunity_type',
      new LookupModelLookupProvider(dictionaryService, LOOKUP_MODELS_ENUM.QUOTE_OPPORTUNITY_TYPE.modelName, true, true));
  }
}
